import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ImageService
{
    private _imagesLoading = new BehaviorSubject<number>(0);
    private images: Map<HTMLElement, boolean> = new Map();
    private imagesLoading = 0;

    imagesLoading$ = this._imagesLoading.asObservable();

    imageLoading(img: HTMLElement)
    {
        if (!this.images.has(img) || this.images.get(img))
        {
            this.images.set(img, false);
            this.imagesLoading++;
            this._imagesLoading.next(this.imagesLoading);
        }
    }

    forceImageLoadingCount = () =>
    {
        this.imagesLoading++;
        this._imagesLoading.next(this.imagesLoading);
    }

    imageLoadedOrError(img: HTMLElement)
    {
        if (this.images.has(img) && !this.images.get(img))
        {
            this.images.set(img, true);
            this.imagesLoading = Math.max(0, this.imagesLoading - 1);
            this._imagesLoading.next(this.imagesLoading);
        }
    }

    forceImageLoadingUncount = () =>
    {
        this.imagesLoading = Math.max(0, this.imagesLoading - 1);
        this._imagesLoading.next(this.imagesLoading);
    }
}

